module.exports = __webpack_public_path__ + "img/Enmascarar grupo 22@2x.54a4e560.png";